import { Component, OnInit, Input, Output, Inject, HostListener } from '@angular/core';
import { LoginInfo } from '../login-interface';
import { EventEmitter } from '@angular/core';
import { LoginService } from '../services/login.service';
import { Subscriber } from 'rxjs';
import { Observable, of } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { HttpParams } from "@angular/common/http";
import { Router } from '@angular/router';
import { GlobalConstants } from '../Constants';




@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})


export class LoginComponent implements OnInit {

  loginService: LoginService;
  data: Object;
  key;


  @HostListener('document:keypress', ['$event'])
  handleKeyboardEvent(event: KeyboardEvent) {
    this.key = event.key;
    if (this.key == 'Enter')
      this.authenticate(this.loginInfo);
  }

  constructor(@Inject(LoginService) loginService: LoginService, @Inject(HttpClient) http: HttpClient, @Inject('BASE_URL') baseUrl: string,
    @Inject(Router) _router: Router) {
    this.loginService = loginService;
    this.baseURL = baseUrl;
    this.http = http;
    this.router = _router;
  }

  
  http: HttpClient;
  router: Router;
  baseURL = '';
  navigation: any;
  message = '';
  signedin = false;
  loginError = false;
  passresetsuccess = false;
  isChecked = localStorage.getItem("rememberMe");
  loginErrorMessage = "";
  dataLength = 0;
  internalContactId = 0;
  //hawkeyeRoleId = 0;
  email = "";
  regShow = false;
  passreset = false;
  myRecaptcha: any[];
  disableLogin: boolean = true;
  captchaError: boolean = false;
  captchaValidated: boolean = false;
  invalidEmailAddress: boolean = false;
  emailAddress: string = "";


  @Output() showReg: EventEmitter<boolean> = new EventEmitter();
  @Output() loggedIn: EventEmitter<string> = new EventEmitter();
  


  authenticate(loginInfo) {
    if (loginInfo.email != "" && this.captchaValidated == true) {
      this.captchaError = false;
      let params = new HttpParams();
      params = params.append('Email', loginInfo.email);
      params = params.append('Password', loginInfo.password);

      this.http.get(this.baseURL + 'api/Login/AuthenticateLogin', { params: params }).subscribe(data => {
        this.data = data;
        //this.dataLength = data.toString().length;




        if (data != null) {
          this.internalContactId = data["internalContactId"];

          this.email = data["email"];

          if (this.isChecked) {
            localStorage.setItem('rememberMe', 'true');
            localStorage.setItem("email", this.email);
          } else {
            localStorage.removeItem('rememberMe');
            localStorage.removeItem("email");
          }




          let params = new HttpParams();
          params = params.append('InternalContactId', this.internalContactId.toString());


          //this.loggedIn.emit(true);
          sessionStorage.setItem('intcontId', this.internalContactId.toString());


          this.loggedIn.emit(sessionStorage.getItem('intcontId'));


          this.router.navigate(['/', 'dashboard']);


          this.http.get(this.baseURL + 'api/Login/InternalContactLogin', { params: params }).subscribe(data => {


          });
        }
        else {
          this.loginError = true;
          this.loginErrorMessage = "You must enter a valid email / password in order to login. Please try again.";


          let params = new HttpParams();
          params = params.append('Email', loginInfo.email);

          this.http.get(this.baseURL + 'api/Login/InternalContactFailure', { params: params }).subscribe(data => {
          });
        }

      });
    } else {
      if (this.captchaValidated == false) {
        this.captchaError = true;
      }
      if (loginInfo.email == "") {
        this.loginError = true;
        this.loginErrorMessage = "You must enter a valid email / password in order to login. Please try again.";
      }
    }
  }

  registration() {
    this.router.navigate(['/', 'register']);
  }


  loginInfo: LoginInfo = {
    email: '',
    password: '',
    authenticated: ''
  }


  ngOnInit() {
    this.loginInfo.email = localStorage.getItem("email");
    if (sessionStorage.getItem('intcontId') != '0') {
      sessionStorage.setItem('intcontId', '0');

    }

  }


  SendPassReset(email) {

    let params = new HttpParams();
    params = params.append('Email', email);

    this.emailAddress = email;

    this.http.get(this.baseURL + 'api/Login/SendPasswordReset', { params: params }).subscribe(data => {
      console.log(data);
      if (data) {
        this.passresetsuccess = true;
        this.invalidEmailAddress = false;
      }
      else {
        this.passresetsuccess = false;
        this.invalidEmailAddress = true;
      }
     
    });


    
  }

  ShowLogin() {
    this.passreset = false;
  }

  ShowPassReset() {
    this.passreset = true;
  }


  resolved(captchaResponse: any[]) {
    this.myRecaptcha = captchaResponse;


    let params = new HttpParams();
    params = params.append('response', this.myRecaptcha.toString());


    this.http.get('api/Captcha/getCaptchaResponse', { params: params }).subscribe(data => {

      if (data) {
        this.captchaValidated = true;
        this.captchaError = false;
        //allow reset password
        this.disableLogin = false;
      } else {
        //don't allow password reset
        this.disableLogin = true;
        this.captchaValidated = false;
        this.captchaError = true;
        //display error
      }

    });
  }

}
